import {curveLinear, curveMonotoneX} from "d3-shape";

export default {
  Linear: curveLinear,
  Default: curveMonotoneX,
};
